import { useRoutes } from "react-router-dom";
import { lazy, Suspense } from "react";
import TopLoader from "../Preload/TopLoader";

// Lazy load components
const General = lazy(() => import("../Layouts/general"));
const Home = lazy(() => import("../GuessPages/Home"));
const About = lazy(() => import("../GuessPages/About"));
const Contact = lazy(() => import("../GuessPages/Contact"));

// Optional: fallback loader
const Loading = () => <div className="p-4 text-center">Loading...</div>;

export default function Routers() {
  return (
    <Suspense fallback={<TopLoader />}>
      {useRoutes([
        {
          path: "/",
          element: <General />,
          children: [
            { path: "/", element: <Home /> },
            { path: "/about", element: <About /> },
            { path: "/contact", element: <Contact /> },
          ],
        },
      ])}
    </Suspense>
  );
}
